import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@/icons' // icon
import { getJSON, post, patch, put, getDS, DSpost } from '@/utils/request.js'

// 创建事件总线
export const eventBus = new Vue();

import ElementUI from 'element-ui';
import { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import antiDebug from '@/utils/antiDebug';
import SafeDirective, { processImageUrls } from '@/directives/safe';

// 注册全局指令
Vue.directive('safe', SafeDirective);

// 注册全局方法，用于处理 v-html 内容
Vue.prototype.$processImages = processImageUrls;


// antiDebug.init(Vue);

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.use(ElementUI);

// 全局配置 Message 消息提示的偏移量，使其往下移动（必须在 Vue.use(ElementUI) 之后）
Vue.prototype.$message = function(options) {
  if (typeof options === 'string') {
    options = { message: options };
  }
  options.offset = options.offset || 80; // 默认向下偏移80px
  return Message(options);
};
// 保留 Message 的静态方法
['success', 'warning', 'info', 'error'].forEach(type => {
  Vue.prototype.$message[type] = function(options) {
    if (typeof options === 'string') {
      options = { message: options };
    }
    options.type = type;
    options.offset = options.offset || 80;
    return Message(options);
  };
});


// Vue.prototype.$getDS = getDS
// Vue.prototype.$post = post
// Vue.prototype.$DSpost = DSpost
// Vue.prototype.$getJSON = getJSON
// Vue.prototype.$patch = patch
// Vue.prototype.$put = put

new Vue({
  router,
  store,
  mounted() {
    // 隐藏加载动画
    document.getElementById('loadingOverlay').style.display = 'none';
  },
  render: h => h(App)
}).$mount("#app");

